import { canv } from "@/canv/global";

type ApiBoardImageCopyArgs = {
    imagesToCopy: Array<{ sourcePath: string }>;
    info: {
        sourceBoardUid: string;
        sourceBoardAccessToken?: string;
        targetBoardUid: string;
        targetBoardAccessToken?: string;
    };
};
type ApiBoardImageCopyResponse = {
    data: Array<{
        path?: string; // может быть пустым, если не скопировалось
        sourcePath: string;
    }>;
};

export const ApiBoardImageCopy = ({
    imagesToCopy,
    info,
}: ApiBoardImageCopyArgs): Promise<ApiBoardImageCopyResponse> => {
    const url = `${canv.host}/api/board/image/copy`;

    return fetch(url, {
        method: "POST",
        body: JSON.stringify({
            data: imagesToCopy,
            sourceBoardUid: info.sourceBoardUid,
            sourceBoardAccessToken: info.sourceBoardAccessToken,
            targetBoardUid: info.targetBoardUid,
            targetBoardAccessToken: info.targetBoardAccessToken,
        }),
    }).then(async (result) => {
        const json = await result.json();
        if (!result.ok) {
            if (json?.message) {
                throw new Error(json.message);
            }
            throw new Error("Не удалось скопировать изображения, попробуйте еще раз");
        }
        return json;
    });
};
